﻿import {Localize} from "@dp-instant/i18n";
import {getGameLocaleByCommonLocaleCode} from "../../dpCommonPortHelper";

const LOCALE_KEY = "homo-evolution-locale";

function detectLocale() {
    return getGameLocaleByCommonLocaleCode(Localize.defaultLocale);
}

export class Localization {
    _locale = detectLocale();
    _localCharacters = new Set();
    _bitmapFont;
    locales = ["EN"];
    translations = {EN: {}};

    get locale() {
        return this._locale;
    }

    set locale(val) {
        this._locale = val;
        localStorage.setItem(LOCALE_KEY, this._locale);
        this._updateLocaleFont();
    }

    _updateLocaleFont() {
        this._localCharacters.clear();
        // All visible ASCII
        for (let i = 0; i <= 126; i++) {
            this._localCharacters.add(String.fromCharCode(i));
        }
        for (let key in this.translations) {
            let str = this.translations[key][this._locale] || this.translations[key]["EN"];
            for (let i = 0; i < str.length; i++) this._localCharacters.add(str[i]);
        }

        this._bitmapFont = PIXI.BitmapFont.from(
            "GameFont",
            {
                fontFamily: "Rubik",
                fill: 0xffffff,
                align: "center",
                fontSize: 64,
                dropShadow: true,
                dropShadowAlpha: 0.75,
                dropShadowAngle: Math.PI * 0.6,
                dropShadowBlur: 1,
                dropShadowColor: 0x000000,
                dropShadowDistance: 2
            },
            {
                chars: [...this._localCharacters]
            }
        );
        console.log("LOCALE", this._locale, "CHARACTERS:", this._localCharacters.size);
    }

    Init(rawData) {
        rawData = rawData.split("\n").map(ln => ln.split("\t"));
        const [, ...locales] = rawData.shift();
        this.locales = locales.map(l => l.toUpperCase().trim());
        this.translations = rawData.reduce((res, [key, ...strings]) => {
            res[key] = this.locales.reduce((res, locale, idx) => {
                res[locale] = (strings[idx] || strings[0] || "")
                    .replace(/<[^>]*>/g, "") // remove HTML formatting
                    .trim();
                return res;
            }, {});
            return res;
        }, {});
        this.locale = detectLocale();
    }

    SetLanguage(newLang) {
        newLang = (newLang || "").toUpperCase();
        this.locale = this.locales.includes(newLang) ? newLang : this.locales[0];
    }

    Get(key, ...args) {
        if (!this.translations[key]) {
            console.warn("LOCALIZATION key not found:", key);
            return key;
        }

        let translation = this.translations[key][this.locale] || this.translations[key]["EN"];
        for (let i = 0; i < args.length; i++) {
            let reg = new RegExp(`\\{${i}\\}`, "g");
            translation = translation.replace(reg, args[i]);
        }

        let reg = /{(\d+)}/g;
        let missed = translation.match(reg);
        if (missed) {
            console.warn(`LOCALIZATION missing parameters for '${key}':`, missed.join(", "));
            // translation = translation.replace(reg, "");
        }
        return translation;
    }

    Destroy() {}
}
